import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InfoCircle, CloseCircle } from "iconsax-react";
import { Button } from "@/shared/ui";

export default function ContractorOnboardingCard() {
  const { t } = useTranslation("EmployeePortal");
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("contractor_onboarding_dismissed");
    if (dismissed === "true") {
      setIsDismissed(true);
    }
  }, []);

  function handleDismiss() {
    localStorage.setItem("contractor_onboarding_dismissed", "true");
    setIsDismissed(true);
  }

  if (isDismissed) return null;

  return (
    <div className="p-5 radius-lg border surface-container-stroke surface-base-fill flex flex-col gap-4 relative">
      <Button
        variant="secondary"
        isIconButton
        className="absolute top-5 right-5 w-8! h-8! p-0! rounded-md!"
        onClick={handleDismiss}>
        <CloseCircle size={16} color="currentColor" />
      </Button>
      <div className="flex items-center gap-2">
        <div className="w-8 aspect-square flex justify-center items-center surface-secondary-fill content-action-brand radius-xs">
          <InfoCircle size={16} color="currentColor" />
        </div>
        <h3 className="text-display-2xs content-base-primary">{t("overview.contractorOnboarding.title")}</h3>
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-body-regular-sm content-base-primary">{t("overview.contractorOnboarding.accountCreated")}</p>
        <p className="text-body-regular-sm content-base-primary">{t("overview.contractorOnboarding.credentialsSent")}</p>
        <p className="text-body-regular-sm content-base-primary">{t("overview.contractorOnboarding.passwordChanged")}</p>
        <p className="text-body-regular-sm content-base-primary">{t("overview.contractorOnboarding.nextSteps")}</p>
      </div>
    </div>
  );
}

